import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
} from 'reactstrap';
import { getCompanies } from '../actions/Companies';
import * as UsersActions from '../actions/Users';
import * as SystemActions from '../actions/SystemLogs';
import AddUserModal from '../components/AddUserModal';
import Breadcrumbs from '../components/Breadcrumb';
import CompanyAutocomplete from '../components/CompanyAutocomplete';
import DeleteModal from '../components/DeleteModal';
import SetLimitEntries from '../components/SetLimitEntries';
import UpdateUserModal from '../components/UpdateUserModal';
import UsersList from '../components/UsersList';
import WithUserData from '../HOC/withUserData';
import { UserShape, UsersPaginatedShape } from '../PropTypes/Shapes';
import filterIcon from '../Res/Icon/filter.png';
import AddSecurityCodeModal from '../components/AddSecurityCodeModal';
import { ENG_LOCALE } from '../lib/constants';
import AddBulkUsers from '../components/AddBulkUsers';
import { isAdminRole, isTrue } from '../lib/utils';
import { ReactComponent as AddUserSvg } from '../Res/addUsersSvg.svg'
import { ReactComponent as PermissionGroupsSvg } from '../Res/PermisionGroups.svg'
import { getPermissionForComponent } from '../utils/permissionsUtils';
import RequestsList from '../components/RequestsList';
import { ReactComponent as RequestsUser } from '../Res/requests.svg'
import TooltipIcon from '../../src/components/EpikBoxes/EpikBoxDetails/TooltipIcon/TooltipIcon';
import EPIK_CALLS from '../Res/epik-calls.svg';
import { TOOLTIPS_TEXT, COMPANY_TYPE_DROPDOWN } from '../lib/constants';
import { generateUsersReport } from '../actions/Reports';
import "./users.css"
import { RESTRICTED_PERMISSION_GROUPS } from '../utils/constants';
import debounce from 'lodash/debounce';
const filterOptions = ['By Company', 'By Email', 'By Name', 'By Role'];
const adminFilterRole = ['By Email', 'By Role'];
const filterTypeOptions = [{ label: 'All', value: 'All' }, ...COMPANY_TYPE_DROPDOWN];
const permissionGroupOptions = ['All', ...RESTRICTED_PERMISSION_GROUPS];
const BYPermissionGroup = 'By Permission Group';
const filterRoleOptions = {
  other: [
    'All',
    'User',
    'Admin',
    'EnterpriseAdmin',
    'Manufacturer',
    'CompanyGroupAdmin',
  ],
  superAdmin: [
    'All',
    'User',
    'Agent',
    'Admin',
    'EnterpriseAdmin',
    'Manufacturer',
    'CompanyGroupManager',
    'SupportEngineer',
    'SuperAdmin',
    'CompanyGroupAdmin',
  ],
  user: [
    'All',
    'User',
    'Admin',
  ],
};

const isUserSuperAdmin = user => {
  return user.role === 'superAdmin' ? 'superAdmin' : ['user', 'admin'].includes(user.role) ? 'user' : 'other';
};
const checkUserPermission = (u) => {
  const perm = String(getPermissionForComponent('bulkUserUpload', u?.bulkUserUpload) ?? '').toLowerCase();
  const allowed = perm === 'write' || perm === 'both';
  return allowed;
};

class Users extends Component {
  constructor(props) {
    super(props);
    this.exportCallsCSV = this.exportCallsCSV.bind(this);
    this.state = {
      filterBy:
        props.user.role === 'superAdmin' ||
          props.user.role === 'supportEngineer' ||
          props.user.role === 'companyGroupAdmin' ||
          props.user.role === 'companyGroupManager'
          ? 'By Company'
          : 'By Email',
      byCompany: null,
      byType: 'All',
      filterEmailValue: '',
      filterNameValue: '',
      selectedCompany: '',
      roleSelected: '',
      permissionsGroup: '',
      limit: 10,
      sort: {
        name: '',
        order: '',
      },
      requestsStatus: false
    };
    this.textSearchFilter = debounce(this.textSearchFilter.bind(this), 200);
    this.token = localStorage.getItem('jwtToken') || null;
  }
  handleNavigate = () => {
    this.props.history.push('/users/permissionsGroup');
  };
  componentDidMount = async () => {
    const { getUsers, getUsersByCompanyId, user, deleteMode } = this.props;
    if (
      user.role === 'superAdmin' ||
      user.role === 'supportEngineer' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager'
    ) {
      await getUsers(this.token, '', '', '', deleteMode);
    } else {
      await getUsersByCompanyId(this.token, user.company._id);
    }

    // await this.props.getCompanies(this.token, undefined, 'yes');
  };

  getUsersByRole = option => {
    const { filterEmailValue, selectedCompany, roleSelected, byType, filterNameValue } = this.state;
    const {
      getUsers,
      user,
      getUsersByCompanyId,
      filterByEmail,
      filterByCompany,
      filterByName,
    } = this.props;
    const pagination = option || this.getPagination();

    if (
      filterEmailValue === '' &&
      selectedCompany === '' &&
      roleSelected === '' &&
      filterNameValue === ''
    ) {
      if (
        user.role === 'superAdmin' ||
        user.role === 'supportEngineer' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'companyGroupManager'
      ) {
        getUsers(this.token, pagination, byType.toLowerCase(), roleSelected);
      } else {
        getUsersByCompanyId(this.token, user.company._id, pagination, '');
      }
    } else if (filterEmailValue !== '') {
      filterByEmail(
        this.token,
        user.company._id,
        filterEmailValue,
        pagination,
        undefined,
        roleSelected,
      );
    } else if (filterNameValue !== '') {
      filterByName(
        this.token,
        user.company._id,
        filterNameValue,
        pagination,
        undefined,
        roleSelected,
      );
    } else if (selectedCompany !== '') {
      filterByCompany(this.token, selectedCompany, pagination);
    } else if (this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') {
      this.props.filterByCompany(
        this.token,
        this.props.user.company._id,
        pagination,
        undefined,
        this.state.roleSelected,
      );
    } else {
      getUsers(this.token, pagination, byType.toLowerCase(), roleSelected);
    }
  };

  onDelete = async () => {
    const { deleteUser, deleteUserID, addSystemLogs, cancelDeleteUser } = this.props;
    const { deleteUser: user } = this.state;
    const res = await deleteUser(this.token, deleteUserID);

    if (res) {
      const body = {
        actionType: 'system',
        description: `User: ${user.name} with Email: ${user.email} and Role: ${user.role} has been deleted`,
      };

      await addSystemLogs(this.token, body);
      this.getUsersByRole();
    }

    if(!res){
      cancelDeleteUser()
      return;
    }
  };

  onAddUser = async () => {
    const { addedUser, addUser, addSystemLogs } = this.props;
    if (addedUser.name) addedUser.name = addedUser.name.trim();
    if (addedUser.email) addedUser.email = addedUser.email.trim();
    const res = await addUser(this.token, addedUser.company, addedUser);
    if (res) {
      const body = {
        actionType: 'system',
        description: `User: ${addedUser.name} with Email: ${addedUser.email} and Role: ${addedUser.role} has been added`,
      };

      await addSystemLogs(this.token, body);
      this.getUsersByRole();
    }
  };

  onSetStatus = async (id, status, type) => {
    const { setUserStatus } = this.props;
    const res = await setUserStatus(this.token, id, status, type);
    if (res) {
      this.getUsersByRole();
    }
  };

  handleChangePagination = page => {
    const { limit } = this.props.users;
    const pagination = { page, limit };
    this.getUsersByRole(pagination);
  };

  getPagination = () => {
    const { page, limit } = this.props.users;
    const pagination = { page, limit };
    return pagination;
  };

  handleSetLimit = limit => {
    const pagination = { page: 1, limit };
    this.setState({ limit });

    if (this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') {
      this.props.filterByCompany(
        this.token,
        this.props.user.company._id,
        pagination,
        undefined,
        this.state.roleSelected,
      );
    } else {
      this.getUsersByRole(pagination);
    }
  };

  onUpdateUser = async () => {
    const {
      updateUser,
      updateUserById,
      initialUpdateUserData,
      closeUpdateUser,
      updateUserData,
      addSystemLogs,
    } = this.props;

    if (updateUserData.name) updateUserData.name = updateUserData.name.trim();
    const res = await updateUserById(this.token, updateUser._id, {
      ...updateUserData,
    });

    if (res && res.status === 200) {
      closeUpdateUser();
      initialUpdateUserData({});
      if (updateUserData.role) {
        const body = {
          actionType: 'system',
          description: `User : ${updateUser?._id}'s Role updated to ${updateUserData?.role} `,
        };
        await addSystemLogs(this.token, body);
      }
      if (Object.hasOwn(updateUserData, 'ttyOptionsAccess')) {
        const readAccess = updateUserData?.ttyOptionsAccess?.read
        const writeAccess = updateUserData?.ttyOptionsAccess?.read
        const msg = `User: ${updateUser?.email} has been ${readAccess ? 'granted' : 'removed'} Read permission and ${writeAccess ? 'granted ' : 'removed '} Write permission on OOBM TTY access by ${this.props.user.email}`

        const body = {
          actionType: 'system',
          description: msg
        };
        await addSystemLogs(this.token, body);
      }

      this.getUsersByRole();
    }
  };

  selectSearchFilter = e => {
    this.setState({ filterBy: e, filterNameValue: '' });
  };
  componentWillUnmount() {
    if (this.textSearchFilter?.cancel) {
      this.textSearchFilter.cancel();
    }
  }

  textSearchFilter = async e => {
    const { filterByEmail, getUsers, user, filterByName } = this.props;
    const pagination = { page: 1, limit: this.state.limit };
    if (this.state.filterBy === 'By Email') {
      this.setState({ filterEmailValue: e }, async () => {
        if (e === '') {
          if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
            this.props.filterByCompany(
              this.token,
              user.company._id,
              pagination,
              undefined,
              this.state.roleSelected,
            );
          } else {
            await getUsers(
              this.token,
              pagination,
              this.state.byType.toLowerCase(),
              this.state.roleSelected,
            );
          }
        } else {
          await filterByEmail(
            this.token,
            user.company._id,
            e,
            pagination,
            undefined,
            this.state.roleSelected,
          );
        }
      });
    } else if (this.state.filterBy === 'By Name') {
      this.setState({ filterNameValue: e }, async () => {
        if (e === '') {
          if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
            this.props.filterByCompany(
              this.token,
              this.props.user.company._id,
              pagination,
              undefined,
              this.state.roleSelected,
            );
          } else {
            await getUsers(
              this.token,
              pagination,
              this.state.byType.toLowerCase(),
              this.state.roleSelected,
            );
          }
        } else {
          await filterByName(
            this.token,
            user.company._id,
            e,
            pagination,
            undefined,
            this.state.roleSelected,
          );
        }
      });
    } else if (this.state.filterBy === 'By Role') {
      this.setState({ filterEmailValue: e }, async () => {
        if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
          this.props.filterByCompany(
            this.token,
            user.company._id,
            pagination,
            undefined,
            this.state.roleSelected,
          );
        } else {
          await getUsers(
            this.token,
            pagination,
            this.state.byType.toLowerCase(),
            this.state.roleSelected,
          );
        }
      });
    }
  };

  filterByCompanyFn = async (name, e) => {
    const { filterByCompany, getUsers } = this.props;
    const pagination = { page: 1, limit: this.state.limit };
    if (name === 'byCompany') {
      if (e.value === null) {
        this.setState({ selectedCompany: '' });
        if (this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') {
          this.props.filterByCompany(
            this.token,
            this.props.user.company._id,
            pagination,
            undefined,
            this.state.roleSelected,
          );
        } else {
          await getUsers(
            this.token,
            pagination,
            this.state.byType.toLowerCase(),
            this.state.roleSelected,
          );
        }
      }
      if (e.suggestion !== undefined && e.suggestion !== null) {
        const companyId = e.suggestion._id;
          const data = {
            company: companyId,
            type: this.state.byType,
          };
          this.setState({ byCompany: companyId, selectedCompany: data }, async () => {
          await filterByCompany(this.token, data, pagination);
        });
      }
    } else {
      this.setState({ selectedCompany: '', companyFilter: '' });
      this.setState({ byType: e.target.value }, async () => {
        await getUsers(
          this.token,
          pagination,
          this.state.byType.toLowerCase(),
          this.state.roleSelected,
        );
        await this.props.getCompanies(
          this.token,
          undefined,
          'yes',
          this.state.byType.toLowerCase(),
          true,
        );
      });
    }
  };

  filterByRoleFn = async e => {
    this.setState(prevState => ({
      ...prevState, // Preserve the other state values
      selectedCompany: '', 
    }))
    const pagination = { page: 1, limit: this.state.limit };
    this.setState({ filterEmailValue: '', filterNameValue: '' });
    let data;
    if (e.target.value === 'SuperAdmin') {
      data = 'superAdmin';
    } else if (e.target.value === 'CompanyGroupAdmin') {
      data = 'companyGroupAdmin';
    } else if (e.target.value === 'CompanyGroupManager') {
      data = 'companyGroupManager';
    } else if (e.target.value === 'SupportEngineer') {
      data = 'supportEngineer';
    } else if (e.target.value === 'QuoteToolAdmin') {
      data = 'quoteToolAdmin';
    }else if (e.target.value === 'EnterpriseAdmin') {
      data = 'enterpriseAdmin';
    } else {
      data = e.target.value.toLowerCase();
    }
    this.setState({ roleSelected: data });
    if (this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') {
      await this.props.filterByCompany(
        this.token,
        this.props.user.company._id,
        pagination,
        undefined,
        data,
      );
    } else {
      await this.props.getUsers(this.token, pagination, this.state.byType.toLowerCase(), data);
    }
  };

  filterByPermissionsGroup = async e => {
    this.setState(prevState => ({
      ...prevState, // Preserve the other state values
      selectedCompany: '',
    }))
    const pagination = { page: 1, limit: this.state.limit };
    this.setState({ filterEmailValue: '', filterNameValue: '' });
    const data = e.target.value === 'All' ? 'all' : e.target.value;
    this.setState({ permissionsGroup: data });
    await this.props.getUsers(this.token, pagination, '', '', '', data,);
  };

  onRecoverUser = async e => {
    const res = await this.props.onRecover(this.token, e);
    if (res) {
      this.getUsersByRole();
    }
  };

  handleSortUsers = filter => {
    const { sort } = this.state;
    const updateSort = { ...sort };

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    this.setState({ sort: updateSort });
  };

  sortColumnByKey = array => {
    const { sort } = this.state;

    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(array, [el => el[sortNameArr[0]][sortNameArr[1]].toLowerCase()], [sort.order]);
    }
    if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    }
    return orderBy(array, [el => el[sort.name]], [sort.order]);
  };

  checkSecurityCode = async () => {
    const { showDeleteUser } = this.props;
    if (this.state.deleteUser) {
      showDeleteUser(this.state.deleteUser._id);
      this.setState({ modalStatus: false });
    } else {
      this.setState({ securityPassed: true });
    }
  };

  showUserRequests = () => {
    // change the url as well to /users/approval-requests
    this.props.history.push('/users/approval-requests');
    // this.setState({ requestsStatus: true });
  }

  showApproverButton = () => {
    const { user } = this.props;
    if (user.role === 'superAdmin' || user.isAccountApprover) {
      return true;
    } 
     else {
      return false;
    }
  }
  exportCallsCSV = async () => {
    const { users, generateUsersReport, user } = this.props;
    
    if (!users.docs.length) {
      toast.warning('No user data available to export.');
      return;
    }
    if (users) {
      let cid = '';
      let userType,role,companyType,company_id
      if (user.role === 'superAdmin') {
        cid = this.state.selectedCompany?.company || this.state.byCompany || '';
        companyType = this.state.byType ? this.state.byType.toLowerCase() : '';
        
        if (this.state.filterBy === "By Company" || this.state.filterBy === "By Role") {
          role = this.state.roleSelected ? this.state.roleSelected : (this.state.filterBy === "By Role" ? "all" : "");
        }
        // Final assignment: if not filtering by role, default to all
        userType = (this.state.filterBy === "By Role")
          ? (this.state.roleSelected || "all")
          : "all";
      }
      if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
        cid = user.company._id;
        userType = this.state.roleSelected ? this.state.roleSelected : 'all';
      }
      if (user.role === 'companyGroupAdmin') {
        company_id = !this.state.selectedCompany?.company ? user.company._id : ''
        companyType = this.state.byType ? this.state.byType.toLowerCase() : 'all';
        role = this.state.roleSelected ? this.state.roleSelected : 'all';
        userType = this.state.roleSelected ? this.state.roleSelected : 'all';
        cid = !this.state.selectedCompany?.company  ? "" : ""
        
        if (this.state.selectedCompany?.company) {
          companyType = this.state.byType ? this.state.byType.toLowerCase() : 'all';
          role = this.state.roleSelected ? this.state.roleSelected : 'all';
          userType = this.state.roleSelected ? this.state.roleSelected : 'all';
          cid = this.state.selectedCompany?.company;
        }
      }
      try {
        await generateUsersReport(this.token, cid, company_id, role, companyType, userType);
      } catch (error) {
        toast.error('Error generating report.');
      }
    }
  };
  render() {
    const {
      user,
      users,
      showDeleteUser,
      usersLoading,
      showAddUser,
      deleteShow,
      cancelDeleteUser,
      addUserShow,
      cancelAddUser,
      updateUserShow,
      closeUpdateUser,
      initialUpdateUserData,
      deleteMode,
    } = this.props;
    const { sort, requestsStatus } = this.state;
    const renderList = sort.name.length
      ? users?.docs?.length && this.sortColumnByKey(users.docs)
      : users.docs;

    return (
      <div>
        <div className="filter-section">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <Row className="justify-content-end">
                <Col md={2} lg={4} sm={4}>
                  <div className="fixed-left-icons">
                   <div>
                    <Row>
                      {this.showApproverButton() ? (
                        <Col md={{ size: 1 }} className="d-flex justify-content-end">
                          <Button
                            color="default"
                            className="btn-circle btn-md"
                            onClick={this.showUserRequests}
                            style={{
                              padding: 0,
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: '#EAECEF',
                            }}
                          >
                            <RequestsUser
                              width={50}
                              height={50}

                            />
                          </Button>
                        </Col>
                      ) : null}
                      {checkUserPermission(user) ? (
                        <AddBulkUsers getUsersByRole={this.getUsersByRole} />
                      ) : null}
                      {(user.role === 'admin' ||
                        user.role === 'enterpriseAdmin' ||
                        user.role === 'superAdmin' ||
                        user.role === 'supportEngineer' ||
                        user.role === 'companyGroupAdmin' ||
                        user.role === 'companyGroupManager') && (
                          <Button
                            color="default"
                            className="float-right"
                            onClick={showAddUser}
                            style={{
                              padding: 0,
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: '#EAECEF',
                              marginLeft: '15px',
                            }}
                          >
                            <AddUserSvg width={50} height={50} />
                          </Button>
                        )}
                        {(isTrue(user.epikEngineering)) && 
                        (
                            <Button
                            color="default"
                            className="float-right"
                            onClick={this.handleNavigate}
                            style={{
                              padding: 0,
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: '#EAECEF',
                              marginLeft: '15px',
                            }}
                          >
                            <PermissionGroupsSvg width={50} height={50} />
                          </Button>
                        )}
                    </Row>
                  </div>
                  </div>
                  {/* end */}
                  <Row className="justify-content-end">
                    {(user.role === "superAdmin" || user.role === "enterpriseAdmin" || user.role === "admin" || user.role === "companyGroupAdmin") && (
                      <Col md={2}>
                        <div
                          style={{
                            position: 'relative',
                            height: '30px',
                            cursor: ((this.state.filterBy === 'By Name' && this.state.filterNameValue !== '' ) || (this.state.filterBy === 'By Email' && this.state.filterEmailValue !== '')) ? 'not-allowed' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: ((this.state.filterBy === 'By Name'  && this.state.filterNameValue !== '') || (this.state.filterBy === 'By Email' && this.state.filterEmailValue !== '')) ? 0.5 : 1,
                          }}
                          onClick={(e) => {
                            if (this.state.filterNameValue === '' || this.state.filterEmailValue === '') {
                              e.preventDefault();
                              e.stopPropagation();
                              this.exportCallsCSV();
                            }
                          }}
                        >
                          <img
                            src={EPIK_CALLS}
                            alt="User Export"
                            style={{
                              height: '100%',
                              cursor: (this.state.filterBy === 'By Name' && this.state.filterNameValue !== '') || (this.state.filterBy === 'By Email'  && this.state.filterEmailValue !== '' )? 'not-allowed' : 'pointer',
                              transition: 'none',
                            }}
                          />
                        </div>
                      </Col>
                    )}

                  </Row>
                </Col>
                {user.role === 'superAdmin' ||
                  user.role === 'supportEngineer' ||
                  user.role === 'companyGroupAdmin' ||
                  user.role === 'companyGroupManager' ? (
                  <Col md={2} sm={12} style={{ paddingRight: '0px' }}>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend" className="filter-icon-div">
                        <img src={filterIcon} className="filter-icon" alt="filter" />
                      </InputGroupAddon>
                      <Input
                        type="select"
                        className="filter-append-dropdown"
                        onChange={e => this.selectSearchFilter(e.currentTarget.value)}
                      >
                          {[...filterOptions, ...(isTrue(user.epikEngineering)) ? [BYPermissionGroup] : []].map(el => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </Input>
                    </InputGroup>
                  </Col>
                ) : (
                  <Col md={2} sm={12} style={{ paddingRight: '0px' }}>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend" className="filter-icon-div">
                        <img src={filterIcon} className="filter-icon" alt="filter" />
                      </InputGroupAddon>
                      <Input
                        type="select"
                        className="filter-append-dropdown"
                        onChange={e => this.selectSearchFilter(e.currentTarget.value)}
                      >
                        {adminFilterRole.map(el => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </Input>
                    </InputGroup>
                  </Col>
                )}

                {(this.state.filterBy === 'By Company' &&
                  (this.props.companies.docs && (
                    <>
                      <Col md={2} sm={12} style={{ paddingLeft: '0px' }}>
                        <FormGroup style={{ width: '100%', margin: '0px' }}>
                          <CompanyAutocomplete
                            searchTerm={this.state.companyFilter}
                            placeholder="Filter"
                            companies={this.props.companies.docs}
                            onChange={e => this.filterByCompanyFn('byCompany', e)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={2} sm={12}>
                        <InputGroup style={{ marginLeft: '10px' }}>
                          <InputGroupAddon addonType="prepend" className="filter-icon-div">
                            <img src={filterIcon} className="filter-icon" alt="filter" />
                          </InputGroupAddon>
                          <Input type="select" onChange={e => this.filterByCompanyFn('byType', e)}>
                            {filterTypeOptions.map(el => (
                              <option key={el.value} value={el.value}>
                                {el.label}
                              </option>
                            ))}
                          </Input>
                        </InputGroup>
                      </Col>
                    </>
                  ))) ||
                  (this.state.filterBy === 'By Name' && (
                    <>
                      <Col md={2} sm={12} style={{ paddingLeft: '0px' }}>
                        <Input
                          type="text"
                          value={this.state.filterNameValue}
                          placeholder="Filter"
                          // onChange={e => this.textSearchFilter(e.target.value)}
                          onChange={(e) => {
                            const value = e.target.value;
                              this.setState({ filterNameValue: value });
                             this.textSearchFilter(value);
                          }}
                        />
                      </Col>
                      <Col md={2} sm={12}>
                        <InputGroup style={{ marginLeft: '10px' }}>
                          <InputGroupAddon addonType="prepend" className="filter-icon-div">
                            <img src={filterIcon} className="filter-icon" alt="filter" />
                          </InputGroupAddon>

                          <Input type="select" onChange={e => this.filterByRoleFn(e)}>
                            {filterRoleOptions[`${isUserSuperAdmin(user)}`].map(el => (
                              <option key={el} value={el}>
                                {el}
                              </option>
                            ))}
                          </Input>
                        </InputGroup>
                      </Col>
                    </>
                  )) ||
                  (this.state.filterBy === 'By Role' && (
                    <Col md={2} sm={12} style={{ paddingLeft: '0px' }}>
                      <Input type="select" onChange={e => this.filterByRoleFn(e)}>
                        {filterRoleOptions[`${isUserSuperAdmin(user)}`].map(el => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </Input>
                    </Col>
                  )) ||
                  (this.state.filterBy === BYPermissionGroup && (
                    <Col md={2} sm={12} style={{ paddingLeft: '0px' }}>
                      <Input type="select" onChange={e => this.filterByPermissionsGroup(e)}>
                        {permissionGroupOptions.map(el => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </Input>
                    </Col>
                  )) || (
                    <>
                      <Col md={2} sm={12} style={{ paddingLeft: '0px' }}>
                        <Input
                          type="text"
                          value={this.state.filterEmailValue}
                          placeholder="Filter"
                          // onChange={e => this.textSearchFilter(e.target.value)}
                          onChange={(e) => {
                            const value = e.target.value;
                            this.setState({ filterEmailValue: value }); 
                            this.textSearchFilter(value);
                          }}
                        />
                      </Col>
                      <Col md={2} sm={12}>
                        <InputGroup style={{ marginLeft: '10px' }}>
                          <InputGroupAddon addonType="prepend" className="filter-icon-div">
                            <img src={filterIcon} className="filter-icon" alt="filter" />
                          </InputGroupAddon>

                          <Input type="select" onChange={e => this.filterByRoleFn(e)}>
                            {filterRoleOptions[`${isUserSuperAdmin(user)}`].map(el => (
                              <option key={el} value={el}>
                                {el}
                              </option>
                            ))}
                          </Input>
                        </InputGroup>
                      </Col>
                    </>
                  )}
              </Row>
            </Col>
          </Row>
        </div>
        <Container fluid className="customClass" style={{ margin: 0 }}>
          {
            requestsStatus ?
              <div className="viewContainer" style={{ marginTop: '20px' }}>
                <RequestsList
                  sortValue={sort}
                  onSort={this.handleSortUsers}
                />
                {/* {users.totalPages > 1 && (
                  <Row className="justify-content-md-center">
                    <SetLimitEntries onChange={this.handleSetLimit} />

                    <Pagination
                      locale={ENG_LOCALE}
                      className="pagination-container"
                      onChange={this.handleChangePagination}
                      current={users.page}
                      total={users.totalDocs}
                      pageSize={users.limit}
                      showLessItems
                      showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                    />
                  </Row>
                )} */}
              </div>
              :
              <div className="viewContainer" style={{ marginTop: '20px' }}>
                <UsersList
                  onRecover={this.onRecoverUser}
                  deleteMode={deleteMode}
                  users={renderList}
                  disabledUser={user._id}
                  onDelete={e => {
                    this.setState({ deleteUser: e }, () => {
                      if (user.role === 'superAdmin' && e.role === 'superAdmin') {
                        this.setState({ modalStatus: true });
                      } else {
                        showDeleteUser(e._id);
                      }
                    });
                  }}
                  onSetStatus={this.onSetStatus}
                  isLoading={usersLoading}
                  sortValue={sort}
                  onSort={this.handleSortUsers}
                />
                {users.totalPages > 0 && (
                  <Row className="justify-content-md-center">
                    <SetLimitEntries onChange={this.handleSetLimit} />

                    <Pagination
                      locale={ENG_LOCALE}
                      className="pagination-container"
                      onChange={this.handleChangePagination}
                      current={users.page}
                      total={users.totalDocs}
                      pageSize={users.limit}
                      showLessItems
                      showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                    />
                  </Row>
                )}
              </div>
          }
          <DeleteModal
            message="Do you really want to delete the User ?"
            isOpen={deleteShow}
            onCancel={cancelDeleteUser}
            onConfirm={this.onDelete}
          />
          {updateUserShow && (
            <UpdateUserModal
              isOpen={updateUserShow}
              onCancel={() => {
                closeUpdateUser();
                initialUpdateUserData({});
              }}
              onConfirm={this.onUpdateUser}
              showSecurityModal={() => this.setState({ modalStatus: true })}
              hideSecurityModal={() => this.setState({ modalStatus: false, securityPassed: false })}
              securityPassed={this.state.securityPassed}
            />
          )}

          <AddSecurityCodeModal
            isOpen={this.state.modalStatus}
            onCancel={() => {
              this.setState({ modalStatus: false, deleteUser: false });
            }}
            onConfirm={this.checkSecurityCode}
            onWrongCode={() => {
              this.setState({ securityPassed: false });
            }}
            // modalName={this.state.securityPassed ? "delete user" : "update user"}
            featureName={this.state.securityPassed ? "deleteUser" : "updateUser"}
          />
          <AddUserModal isOpen={addUserShow} onCancel={cancelAddUser} onConfirm={this.onAddUser} />
        </Container>
      </div>
    );
  }
}

Users.propTypes = {
  user: UserShape.isRequired,
  users: UsersPaginatedShape.isRequired,
  deleteShow: PropTypes.bool.isRequired,
  addUserShow: PropTypes.bool.isRequired,
  deleteUserID: PropTypes.string,
  usersLoading: PropTypes.bool.isRequired,
  addedUser: UserShape.isRequired,
  // Actions
  addUser: PropTypes.func.isRequired,
  showAddUser: PropTypes.func.isRequired,
  cancelAddUser: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  showDeleteUser: PropTypes.func.isRequired,
  cancelDeleteUser: PropTypes.func.isRequired,
  setUserStatus: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  getUsersByCompanyId: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.AppState.user,
  users: state.AppState.users,
  deleteShow: state.UIState.users.deleteShow,
  addUserShow: state.UIState.users.addUserShow,
  deleteUserID: state.UIState.users.deleteUserID,
  usersLoading: state.UIState.users.usersLoading,
  addedUser: state.UIState.users.addedUser,
  updateUserShow: state.UIState.users.updateUserShow,
  updateUser: state.UIState.users.updateUser,
  updateUserData: state.UIState.users.updateUserData,
  companyFilter: state.UIState.epikBoxes.companyFilter,
  companies: state.AppState.companies,
  deleteMode: state.AppState.deleteMode,
  securityCode: state.UIState.users.addedUser.security,
});

const mapDispatchToProps = dispatch => ({
  onRecover: (token, id) => dispatch(UsersActions.onRecover(token, id)),
  addUser: (token, companyId, user) => dispatch(UsersActions.addUser(token, companyId, user)),
  addSystemLogs: (token, body) => dispatch(SystemActions.addSystemLogs(token, body)),
  showAddUser: () => dispatch(UsersActions.showAddUser()),
  cancelAddUser: () => dispatch(UsersActions.cancelAddUser()),
  deleteUser: (token, id) => dispatch(UsersActions.deleteUser(token, id)),
  showDeleteUser: id => dispatch(UsersActions.showDeleteUser(id)),
  cancelDeleteUser: () => dispatch(UsersActions.cancelDeleteUser()),
  setUserStatus: (token, id, status, type) =>
    dispatch(UsersActions.setUserStatus(token, id, status, type)),
  getUsers: (token, pagination, companyType, role, getDeleted, permissionsGroup) =>
    dispatch(UsersActions.getUsers(token, pagination, companyType, role, getDeleted, permissionsGroup)),
  getUsersByCompanyId: (token, id, pagination, disabledPagination) =>
    dispatch(UsersActions.getUsersByCompanyId(token, id, pagination, disabledPagination)),
  filterByEmail: (token, id, email, pagination, disablePaginate, role) =>
    dispatch(UsersActions.filterByEmail(token, id, email, pagination, disablePaginate, role)),

  filterByName: (token, id, name, pagination, disablePaginate, role) =>
    dispatch(UsersActions.filterByName(token, id, name, pagination, disablePaginate, role)),
  filterByCompany: (token, id, pagination, disabledPagination, userType) =>
    dispatch(UsersActions.filterByCompany(token, id, pagination, disabledPagination, userType)),
  getCompanies: (token, pagination, disabledPagination, type, onlyName) =>
    dispatch(getCompanies(token, pagination, disabledPagination, type, undefined, onlyName)),
  closeUpdateUser: () => dispatch(UsersActions.closeUpdateUser()),
  initialUpdateUserData: userObj => dispatch(UsersActions.initialUpdateUserData(userObj)),
  updateUserById: (token, id, userObj) => dispatch(UsersActions.updateUserById(token, id, userObj)),
  generateUsersReport: (token, cid, company_id, role, companyType,userType) =>
    dispatch(generateUsersReport(token, cid, company_id, role, companyType,userType)),
  
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Users));
